// CardBase.tsx

import { Card } from '@mui/material'
import React, { PropsWithChildren } from 'react'

export interface IPageHeaderProps {
  subtitle?: string
  title: string
}

export default function CardBase({ children }: PropsWithChildren<Record<string, unknown>>) {
  return (
    <Card sx={{ display: 'flex', maxHeight: '100vh', height: '100%', width: '100%', borderRadius: '20px' }}>
      {children}
    </Card>
  )
}
